import { setConfiguration } from "react-grid-system";
export { wrapRootElement } from "./gatsby/wrapRootElement";

setConfiguration({ maxScreenClass: "xl", defaultScreenClass: "xl" });
